import React from 'react';
import HeaderLogo from './HeaderLogo';
import HeaderIconsComponent from './HeaderIcons';

export const Header = () => (
  <div id="header" className="header navbar-default">
    <HeaderLogo />
    <HeaderIconsComponent />
  </div>
);
export default Header;
